// src/oauth/GoogleSuccess.jsx
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function GoogleSuccess({ setIsLoggedIn, setUsername }) {
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const access = params.get("access");
    const refresh = params.get("refresh");

    if (access && refresh) {
      // ⬇️ Tokenek mentése UGYANÚGY, mint a normál login után
      localStorage.setItem("access_token", access);
      localStorage.setItem("refresh_token", refresh);
      localStorage.setItem("isLoggedIn", "true");

      // Opcionális: profil lekérése, hogy a username is meglegyen
      fetch(`${process.env.REACT_APP_API}/api/user-profile/`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${access}`,
        },
      })
        .then((res) => res.json())
        .then((data) => {
          const username =
            data?.user_data?.username ||
            data?.user_data?.email ||
            "Felhasználó";
          localStorage.setItem("username", username);
          if (setUsername) setUsername(username);
        })
        .catch((err) => {
          console.error("Hiba a user profil lekérésénél:", err);
        })
        .finally(() => {
          // Bejelentkezett állapot beállítása
          if (setIsLoggedIn) setIsLoggedIn(true);
          // megyünk a root-ra, ahol már a user_type alapján irányítasz
          navigate("/", { replace: true });
        });
    } else {
      // Ha valami gáz volt, vissza loginra
      navigate("/login?error=missing_tokens", { replace: true });
    }
  }, [navigate, setIsLoggedIn, setUsername]);

  return <p>Bejelentkezés Google fiókkal, kérlek várj...</p>;
}
